import * as Sentry from "@sentry/browser";

/**
 * Error monitoring only — no always-on Feedback / "Report a Bug" button.
 * Bug reporting UI lives on error pages via errors/partials/sentry-report.blade.php.
 */
Sentry.init({
    dsn: "https://5e11ca2e818d44ef7ca9e2ff129bdf68@o292934.ingest.us.sentry.io/4509826676817920",
    sendDefaultPii: true,
    integrations: [],
    debug: import.meta.env.DEV,
    beforeSend(event, hint) {
        if (hint.originalException &&
            typeof hint.originalException === 'object' &&
            hint.originalException.isFromCancelledTransition) {
            console.warn('Filtered out Alpine.js cancelled transition error');
            return null;
        }

        if (event.exception &&
            event.exception.values &&
            event.exception.values.some(exception =>
                exception.type === 'UnhandledRejection' &&
                exception.value &&
                exception.value.includes('isFromCancelledTransition')
            )) {
            console.warn('Filtered out cancelled transition promise rejection');
            return null;
        }

        return event;
    }
});

window.Sentry = Sentry;

export default Sentry;
